import React, { useRef, useState } from "react";
import frame6 from '../../assets/frames/frame6.png';
import "./PhoneTilt.css";

const YOUTUBE_VIDEO_ID = "hGGm0pXCxS4"; 

export default function PhoneTilt({ progress }) {
  const imgRef = useRef(null);
  const [showVideo, setShowVideo] = useState(false);

  const isCentered = progress > 0.98;

  const initialTranslateX = 520;
  const finalTranslateX = 0;
  const initialRotateY = -28;
  const finalRotateY = 0;
  const initialScale = 1.25;
  const finalScale = 1;

  const translateX = initialTranslateX + (finalTranslateX - initialTranslateX) * progress;
  const rotateY = initialRotateY + (finalRotateY - initialRotateY) * progress;
  const scale = initialScale + (finalScale - initialScale) * progress;

  const handleMouseMove = (e) => {
    if (!isCentered || showVideo) return; 
    const img = imgRef.current;
    const rect = img.getBoundingClientRect();
    const x = ((e.clientX - rect.left) / rect.width - 0.5) * 2;
    const y = ((e.clientY - rect.top) / rect.height - 0.5) * 2;
    img.style.transform = `
      perspective(900px)
      rotateY(${x * 16}deg)
      rotateX(${-y * 12}deg)
      scale(${scale})
    `;
  };
  const handleMouseLeave = () => {
    if (!isCentered || showVideo) return;
    const img = imgRef.current;
    img.style.transform = `perspective(900px) rotateY(0deg) rotateX(0deg) scale(${scale})`;
  };

  const handleCloseVideo = () => setShowVideo(false);

  return (
    <div
      className="phone-tilt-container"
      style={{
        flex: isCentered ? "1 1 100%" : "1 1 0",
        justifyContent: "center",
        alignItems: "center",
        display: "flex",
        position: "relative",
        transform: `
          translateX(${translateX}px)
          scale(${scale})
          perspective(900px)
          rotateY(${rotateY}deg)
        `,
        transition: "transform 0.7s cubic-bezier(.85,0,.15,1), flex 0.4s",
      }}
      onMouseMove={handleMouseMove}
      onMouseLeave={handleMouseLeave}
    >
      <img
        ref={imgRef}
        src={frame6}
        alt="Teléfono 3D"
        className="phone-tilt-image"
        draggable={false}
        style={{
          transition: "transform 0.4s cubic-bezier(.65,1.65,.32,1)",
          width: "100%",
          maxWidth: "950px",
        }}
      />

      {isCentered && (
        <div className="phone-video-overlay">
          {!showVideo && (
            <button
              className="phone-video-play-btn"
              aria-label="Reproducir video"
              onClick={() => setShowVideo(true)}
            >
              <svg width={82} height={82} viewBox="0 0 90 90" fill="none">
                <circle cx={45} cy={45} r={45} fill="rgba(0,0,0,0.68)" />
                <polygon points="37,27 67,45 37,63" fill="#fff" />
              </svg>
            </button>
          )}
          {showVideo && (
            <>
              <button className="phone-video-close-btn" onClick={handleCloseVideo} aria-label="Cerrar video">
                &times;
              </button>
              <iframe
                className="phone-video-iframe"
                src={`https://www.youtube.com/embed/${YOUTUBE_VIDEO_ID}?autoplay=1&rel=0`}
                title="Video de YouTube"
                allow="autoplay; encrypted-media"
                allowFullScreen
              />
            </>
          )}
        </div>
      )}
    </div>
  );
}
